import React, { useState, useCallback, useEffect } from 'react'
import styled from 'styled-components'

import useCancelBid from '../../../hooks/nft/useCancelBid'
import { stopPropagation } from '../../../utils/func'

import { ButtonConfirmed } from '../../Button'
import { AutoRow } from '../../Row'
import Loader from '../../Loader'
import useUserBids from '../../../hooks/nft/useUserBids'
import { userTokenName } from '../../../userType/userTokenName'
import useYam from '../../../hooks/bakery/useYam'
import { useActiveWeb3React } from '../../../hooks'
import { useMarketLevel } from '../../../state/market/hooks'

const Button = styled(ButtonConfirmed)`
  border: none;
  font-size: 14px;
  width: 244px;
  height: 40px;
  border-radius: 10px;
  padding: 0;
`

export default function CancelBtn ({
  marketType, artwork, symbol
}: {
  marketType: string, artwork: any, symbol: string
}) {
  // 竞价单重新获取币种
  const [resetSymbol, setResetSymbol] = useState(symbol)

  // 获取我的竞价
  const level = useMarketLevel()
  const { account } = useActiveWeb3React()
  const sushi = useYam()
  const getMyBids = useUserBids(marketType)
  const getMyIds = useCallback(async() => {
    const myBids = await getMyBids()
    if (myBids.length) {
      // eslint-disable-next-line array-callback-return
      myBids.map((d: any) => {
        if(d[0] + '-' + d[3] === artwork.nftId + '-' + artwork.nftType){
          let symbolReset = userTokenName(sushi, d[2])
          setResetSymbol(symbolReset)
        }
      })
    }
  }, [getMyBids, artwork, sushi])

  useEffect(() => {
    if (level === 'v2' && account) {
      getMyIds()
    }
  }, [getMyIds, getMyBids, level, account, artwork])


  // 移除竞价
  const cancelBid = useCancelBid(artwork.tokenId, marketType, resetSymbol)
  const [requestedCancel, setRequestedCancel] = useState(false)
  const onCancelBid = useCallback(async(event) => {
    stopPropagation(event)
    try {
      setRequestedCancel(true)
      const txHash = await cancelBid()
      if (!txHash) {
        setRequestedCancel(false)
      } else {
        setTimeout(() => {
          setRequestedCancel(false)
        }, 10000)
      }
    } catch (e) {
      console.log(e)
    }
  }, [cancelBid])

  return (
    <Button
      disabled={requestedCancel}
      onClick={onCancelBid}
      altDisabledStyle={requestedCancel}
    >
      { 
        requestedCancel ? (
          <AutoRow gap="6px" justify="center">
            Pending <Loader stroke="white" />
          </AutoRow>
        ) : (
          'Cancel'
        )
      }
    </Button>
  )
}